import React, { cloneElement, useEffect, useMemo, useState, createElement } from 'react';
import { isInViewport, scrollToPx } from '../../utils/ui';
import classNames from 'classnames';
let timeoutId;
const Accordion = (props) => {
    const [expandedCard, setExpandedCard] = useState();
    const [height, setHeight] = useState(0);
    const groupRef = React.createRef();
    const setOpen = (i) => {
        setExpandedCard(i);
    };
    const isOpen = (i) => {
        return expandedCard === i;
    };
    const onChildSelect = (i) => {
        setOpen(isOpen(i) ? null : i);
    };
    // OE-14667 set the accordion close if there is a new result in the search input
    useEffect(() => {
        if (props.results && props.results.length > 0) {
            setOpen(-1);
        }
    }, [props.results]);
    const scrollToElement = (container, opener) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            if (!isInViewport(opener)) {
                const scrollPosition = window.scrollY;
                const containerScrollPosition = container.getBoundingClientRect().top;
                let header = document.querySelector('header');
                const headerHeight = header && header.offsetHeight;
                const gap = 100;
                const scrollPositionFinal = scrollPosition + containerScrollPosition - headerHeight - gap;
                scrollToPx(scrollPositionFinal);
            }
        }, 500);
    };
    useEffect(() => {
        let defaultOpen;
        React.Children.forEach(props.children, (c, i) => {
            if (!!c) {
                if (React.isValidElement(c)) {
                    if (c.props.isInitialOpen) {
                        defaultOpen = c.key || i;
                    }
                }
                else {
                    console.warn('Element is not an accordion item.', c);
                }
            }
        });
        setOpen(defaultOpen);
    }, []);
    useEffect(() => {
        console.log('set accordion height');
        setHeight(groupRef.current.clientHeight);
    }, []);
    const childrenLength = useMemo(() => {
        let counter = 0;
        React.Children.map(props.children, () => {
            counter += 1;
        });
        return counter;
    }, []);
    // causava sfarfallamenti
    // const disableScroll = () => {
    //   if (timeout) {
    //     clearTimeout(timeout);
    //   }
    //   document.documentElement.classList.add('initial-scroll');
    //   const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    //   const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    //   window.onscroll = () => {
    //     window.scrollTo(scrollLeft, scrollTop);
    //   };
    // };
    // const enableScroll = () => {
    //   document.documentElement.classList.remove('initial-scroll');
    //   window.onscroll = () => {};
    // };
    return createElement(props.type, {
        className: classNames('accordion__group', { 'accordion__group--flex': props.flex, 'accordion__group--list': props.type === 'ul' }),
        ref: groupRef,
        style: { gap: props.gap || 0 },
    }, React.Children.map(props.children, (child, i) => {
        if (React.isValidElement(child)) {
            return cloneElement(child, Object.assign({ onSelect: () => onChildSelect(child.key || i), expanded: isOpen(child.key || i), loading: isOpen(child.key || i) && child.props.initiallyClosed, scrollToElement: scrollToElement, flex: props.flex, gap: props.gap, parentHeight: height, childrenLength: childrenLength, type: (props.type === 'ul' && 'li') || 'div' }, child.props));
        }
    }));
};
Accordion.defaultProps = {
    type: 'div',
};
export default Accordion;
